'use strict';
/**
 * View States
 */
export const VSTATES = {
    WORKING: -4,
    ERROR: -3,
    NO_ACCESS: -2,
    NOT_FOUND: -1,
    LOADING: 0,
    READY: 1,
    FINISHED: 2,
};
//# sourceMappingURL=vstates.js.map